import NProgress, { start } from 'nprogress'

window.onload = () => {
    let div = document.createElement('div');
    div.innerHTML =
        `<link rel="icon" type="image/png" href="https://en.idcgames.com/favicon.ico">
		<!-- link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/highlight.js/9.10.0/styles/default.min.css" -->
		`;

    document.head.append(...div.children);
}

import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import VueMeta from 'vue-meta'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n';
import linkExpander from './assets/js/linkExpander'

import App from './App'
import store from './store/index'
import VueCookies from 'vue-cookies';
import VCalendar from 'v-calendar';
import VueSlideBar from 'vue-slide-bar'
import CountryFlag from 'vue-country-flag'
import Vuetify from 'vuetify'
import moment from 'moment';
import VueToast from 'vue-toast-notification';
import "vue-toast-notification/dist/index.css";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSteam, faFacebook, faTwitter, faInstagram, faPinterestP, faYoutube, faTwitch, faVk, faTiktok, faDiscord, faGoogle, faFacebookSquare, faSteamSymbol, faYahoo } from '@fortawesome/free-brands-svg-icons'
import {
    faBars,faCode,faSearch,faSignOutAlt,faSignInAlt,faUsers, 
    faQuestionCircle,faFileAlt,faFolderOpen,faWrench,faUser,faKey,faSpinner, faHome, faDollarSign, faEnvelope,
    faBook,faComment,faLifeRing,faGavel,faBullhorn,faClock,faPen,faPenAlt, faArrowLeft, faArrowRight, faExclamation,
    faCamera,faTag,faChevronCircleRight,faImage,faCheckCircle,faTrophy,faBookmark,faComments, faCircle,
    faTimesCircle,faMinusSquare,faPlusSquare,faLock,faGlobe,faCheck,faPlusCircle,faGift, faReply, faTrash,
	faHeart, faMailBulk, faShareAlt, faFlag, faGrinAlt, faBold, faItalic, faUserAstronaut, faCircleNotch, faEdit, faBan,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faBars,faComment,faSignOutAlt,faSignInAlt, faArrowLeft, faArrowRight, faKey,faSpinner, faEnvelope, faBan, faExclamation,
    faSearch,faCode,faUsers, faQuestionCircle, faGift, faPen,faTrophy,faPenAlt,faBookmark,faComments, faDollarSign,
    faFileAlt, faFolderOpen, faWrench, faUser, faSteam, faBook, faComment, faLifeRing, faGavel,faPlusCircle, faHome, faCircle,
    faBullhorn, faClock, faCamera, faTag, faChevronCircleRight, faImage, faCheckCircle, faTimesCircle, faMinusSquare, faPlusSquare,
    faHeart, faMailBulk, faFacebook, faTwitter, faInstagram, faPinterestP, faYoutube, faTwitch, faVk, faTiktok, faDiscord, faGoogle, faFacebookSquare, faSteamSymbol, faYahoo, faLock, faGlobe, faCheck, faShareAlt, faFlag, faGrinAlt, faBold, faItalic, faSignOutAlt, faUserAstronaut, faReply, faCircleNotch,faTrash,faEdit
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('VueSlideBar', VueSlideBar);

const Landing = () => import ('./components/routes/Landing')
const Discussions = () => import ('./components/routes/Discussions')
const Discussion = () => import ('./components/routes/Discussion')
const NewDiscussion = () => import ('./components/routes/NewDiscussion')
const CreatedDiscussion = () => import ('./components/routes/CreatedDiscussion')
const BookMarked = () => import ('./components/routes/BookMarked')
const Subscribed = () => import ('./components/routes/Subscribed')
const User = () => import ('./components/routes/User')
const Giveaway = () => import ('./components/routes/Giveaway')
const NewGiveaway = () => import ('./components/routes/NewGiveaway')
const CreatedGiveaway = () => import ('./components/routes/CreatedGiveaway')
const EnteredGiveaway = () => import ('./components/routes/EnteredGiveaway')
const WonGiveaway = () => import ('./components/routes/WonGiveaway')
const Entries = () => import ('./components/routes/Entries')
const Winners = () => import ('./components/routes/Winners')
const Faq = () => import ('./components/routes/Faq')
const Guidelines = () => import ('./components/routes/Guidelines')
const PrivacyPolicy = () => import ('./components/routes/PrivacyPolicy')
const CookiePolicy = () => import ('./components/routes/CookiePolicy')
const TermsOfService = () => import ('./components/routes/TermsOfService')
const Archive = () => import ('./components/routes/Archive')
const Roles = () => import ('./components/routes/Roles')
const Users = () => import ('./components/routes/Users')
const Wishlist = () => import ('./components/routes/Wishlist')

import NotFound from './components/routes/NotFound'

Vue.prototype.$mMultiLangs = ["ar","bs","cs","da","de","el","en","es","fi","fr","hr","it","ja","ko","nl","no","pl","pt","ro","ru","sr","sv","th","tr","uk","vi","zh"];

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(linkExpander)
Vue.use(VueMeta, {    
    refreshOnceOnNavigation: true
})
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueI18n)
Vue.use(VueCookies)
Vue.use(VCalendar, {
    componentPrefix: 'vc'
})
Vue.use(CountryFlag)
Vue.use(Vuetify)
Vue.use(moment)
Vue.use(VueToast)
Vue.use(VueSweetalert2);

//i18n init
const messages = require('./assets/js/messages')
const i18n = new VueI18n({
  	locale: 'en',
  	fallbackLocale: 'es',
  	formatFallbackMessages: true,
  	messages
})

const router = new VueRouter({
    routes: [
        { path: '/', redirect: '/en/landing', name: 'root'},
		{ path: '/:lang/landing', component: Landing, name: 'landing'},
        //... wishlist page
        {
            path: '/:lang/giveaways/wishlist',
            name: 'wishlist',
            component: Wishlist,
            children: [
                { path: ':price', name: ":price", component: Wishlist },
            ]
        },
        { path: '/:lang/giveaways/search', component: Landing, name: 'search' },
        //... Discussion pages
        {
            path: '/:lang/discussions', component: Discussions, name: 'discussions',
            children: [
                { path: '/:lang/discussions/:category', name: "discussion", component: Discussions }
            ]
        },
        { path: '/:lang/discussion_detail/:title/:id', name: "discussion_detail", component: Discussion },
        { path: '/:lang/discussion/create-new', name: "new-discussion", component: NewDiscussion },
        { path: '/:lang/discussion/created', name: "created-discussion", component: CreatedDiscussion },
        { path: '/:lang/discussion/bookmarked', name: "bookmarked", component: BookMarked },
        { path: '/:lang/discussion/subscribed', name: "subscribed", component: Subscribed },
        {
            path: '/:lang/user',
            component: User,
            name: 'user',
            children: [
                { path: '/:lang/user/:username', name: "userpage", component: User }
            ]
        },        
        //... giveaway page
        {
            path: '/:lang/giveaway/:username/:game_seo/:id',
            name: 'giveaway',
            component: Giveaway,            
        },
        { path: '/:lang/giveaway/create-new', name: "new-giveaway", component: NewGiveaway },
        { path: '/:lang/giveaway/entered', name: "entered-giveaway", component: EnteredGiveaway },
        { path: '/:lang/giveaway/created', name: "created-giveaway", component: CreatedGiveaway },
        { path: '/:lang/giveaway/won', name: "won-giveaway", component: WonGiveaway },

        { path: '/:lang/comments', name: "comments", component: Giveaway },
        { path: '/:lang/giveaways/entries/:giveaway_id', name: "entries", component: Entries },
        { path: '/:lang/giveaways/winners/:giveaway_id', name: "winners", component: Winners },

        //... about pages
        { path: '/:lang/about/faq', name: 'faq', component: Faq },
        { path: '/:lang/about/guidelines', name: 'guidelines', component: Guidelines },

        //... legal pages
        { path: '/:lang/legal/privacy-policy', name: 'privacy-policy', component: PrivacyPolicy },
        { path: '/:lang/legal/cookie-policy', name: 'cookie-policy', component: CookiePolicy },
        { path: '/:lang/legal/terms-of-service', name: 'terms-of-service', component: TermsOfService },

        //... archive pages
        {
            path: '/:lang/archive',
            name: 'archive',
            component: Archive,
            children: [
                { path: ':state', name: "archive/state", component: Archive },
            ]
        },

        //... roles pages
        {
            path: '/:lang/roles',
            name: 'roles',
            component: Roles,
            children: [
                { path: ':level', name: ":level", component: Roles },
            ]
        },

        //... users pages
        {
            path: '/:lang/users',
            name: 'users',
            component: Users,
            children: [
                { path: ':level', name: "users/:level", component: Roles },
            ]
        },

        { path: '*', component: NotFound }
    ],
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    //Init
	let cLang = to.fullPath.split("/")[1];
	router.app.$store.commit('setLang', cLang);
    i18n.locale = cLang;
	i18n.fallbackLocale = cLang;

    router.app.$store.commit('set404Page', false)

    const sPaths = to.fullPath.split("/")
    
    if (!to.name) {
        router.app.$store.commit('set404Page', true)
    }
    
    next()
})

router.afterEach(() => {
    NProgress.done()
})

axios.interceptors.request.use((config) => {

    const lang = (router.app.$store.state.meta.lang || 'en')
  
    config.headers ? config.headers.lang = lang : config.headers = { lang: lang }
  
    return config;
});

Vue.filter('formatDate', function(value, reverse=0) {

    if (typeof value !== 'object') {
        value = new Date(value)
    }

    var end   = reverse ? moment(value) : moment(new Date()); //todays date
    var start = reverse ? moment(new Date()) : moment(value); // another date
	var sinceNow = end.diff(start);//milliseconds

    // ===============================================
    // let sinceNow = new Date(new Date() - value)

    //Add leading zero if under 10
    function lz(num) {
        if (num < 10) {
            return '0' + num;
        } else {
            return '' + num;
        }
    }

    function p(word, num) {
        if (num === 1) {
            return word
        } else {
            return word + 's'
        }
    }

    //2 minutes
    if (sinceNow <= 1000 * 60 * 2) {
        return 'just now';
    } else if (sinceNow <= 1000 * 60 * 60) {
        let Mins = Math.floor(sinceNow / (1000 * 60));
        return Mins + ' minutes';
    } else if (sinceNow <= 1000 * 60 * 60 * 24) {
        let hours = Math.floor(sinceNow / (1000 * 60 * 60));
        return hours + ' ' + p('hour', hours);
    } else if (sinceNow <= 1000 * 60 * 60 * 24 * 30) {
        let days = Math.floor(sinceNow / (1000 * 60 * 60 * 24))
        return days + ' ' + p('day', days);
    } else if (sinceNow <= 1000 * 60 * 60 * 24 * 365) {
        let months = Math.floor(sinceNow / (1000 * 60 * 60 * 24 * 30))
        return months + ' ' + p('month', months);
    } else {
        let years = Math.floor(sinceNow / (1000 * 60 * 60 * 24 * 30 * 12))
        return years + ' ' + p('year', years);
    }
});

Vue.filter('localTime', function(val){
    var utcDate = moment.utc(val);
    var localDate = moment(utcDate).local();
    
    return localDate.format('YYYY-MM-DD HH:mm:ss'); 
});

Vue.filter('differTimeHour', function(value, reverse=0){
    if (typeof value !== 'object') {
        value = new Date(value)
    }

    function ltime(val){
        var utcDate = moment.utc(val);
        var localDate = moment(utcDate).local();
    
        return localDate.format('YYYY-MM-DD HH:mm:ss'); 
    }

    var end   = reverse ? moment(value) : moment(new Date()); //todays date
    var start = reverse ? moment(new Date()) : moment(value); // another date
	var sinceNow = end.diff(start); //milliseconds

    let hours = Math.floor(sinceNow / (1000 * 60 * 60));

    return {nums: hours, unit: 'hours', when: (reverse ? 'remaining' : 'ago') };    
});

Vue.filter('differTimeMinute', function(value, reverse=0){
    if (typeof value !== 'object') {
        value = new Date(value)
    }

    function ltime(val){
        var utcDate = moment.utc(val);
        var localDate = moment(utcDate).local();
    
        return localDate.format('YYYY-MM-DD HH:mm:ss'); 
    }

    var end   = reverse ? moment(value) : moment(new Date()); //todays date
    var start = reverse ? moment(new Date()) : moment(value); // another date
	var sinceNow = end.diff(start); //milliseconds

    let hours = Math.floor(sinceNow / (1000 * 60));

    return {nums: hours, unit: 'min', when: (reverse ? 'remaining' : 'ago') };    
});

Vue.filter('serverTime', function(val){
    var utcDate = moment.utc(val);

    return utcDate.format('YYYY-MM-DD HH:mm:ss'); 
});

Vue.filter('stripTags', function(value) {
    let doc = new DOMParser().parseFromString(value, 'text/html')
    return doc.body.textContent || ''
});

Vue.filter('truncate', function(value, length) {
    if (value.length <= length) {
        return value
    } else {
        return value.slice(0, length) + '…'
    }
});
Vue.filter('truncateMid', function(value, length) {
    if (value.length <= length) {
        return value
    } else {
        let firstLen = Math.round(length / 2);
        let secondLen = length - firstLen;

        return value.slice(0, firstLen) + '…' + value.slice(value.length - secondLen, value.length)
    }
});

Vue.filter('pluralize', function(number, value) {
    if (number === 1) {
        return value
    } else {
        return value + 's'
    }
})

let Root = new Vue({
    i18n,
    store,
    router,
    render: h => h(App)
}).$mount('#app');